import { Text } from "@zapier/design-system";
import { EdgeProps, EdgeLabelRenderer, BaseEdge } from "@xyflow/react";

import styles from "./CustomEdge.module.css";
import { getSmoothStepPath } from "./smoothstep-edge";

const CustomEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  label,
  markerStart,
  markerEnd,
  sourcePosition,
  targetPosition,
}: EdgeProps) => {
  const [edgePath, labelX] = getSmoothStepPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  });

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        markerEnd={markerEnd}
        markerStart={markerStart}
      />
      <EdgeLabelRenderer>
        <div
          style={{
            transform: `translate(-50%, -50%) translate(${
              labelX + 40
            }px,${targetY}px)`,
          }}
          className={styles.edgeLabel}
        >
          <Text type="SmallPrint3">{label}</Text>
        </div>
      </EdgeLabelRenderer>
    </>
  );
};

export default CustomEdge;
